import React, {useEffect} from 'react';
import {makeStyles,} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {getCatalog,} from "@cabinet-packages/redux";
import {Loading} from "@cabinet-packages/components";
import MediaCard from "../components/MediaCard";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  scrollContainer: {
    padding: '0 10px',
    width: '100%',
    height: 'calc(100vh - 50px)',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  rootWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '24px',
    padding: '10px 0 30px',
    width: '100%',
    margin: '0 auto',
    alignItems: 'stretch',

    "@media(min-width: 900px)": {
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    '@media (max-width:600px)': {
      gridTemplateColumns: '1fr',
    },
  },
  headerLabel: {
    fontWeight: 600,
    color: theme.palette.primary.dark
  },
  extraLabel: {
    color: theme.palette.primary.main
  },
  orderButtonContainer: {
    padding: '5px 0',
    '@media (max-width: 1040px)': {
      padding: '5px',
    },
  },
  orderButton: {
    width: '100%',
  },
  card: {
    boxShadow: '0 0 1px 1px rgba(0, 0, 0, 0.1)',
    paddingBottom: '10px',
  },
  img: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  labelsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  label: {
    padding: '5px',
  },
  labelPrice: {
    padding: '5px',
    color: theme.palette.grey.A200,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  moreButtonContainer: {
    padding: '5px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  error: {
    color: theme.palette.error.light,
    textAlign: 'center',
  },
  noResults: {
    textAlign: 'center',
    margin: '50px'
  }
}));

function ListOfPromotions({isComponentInShop}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { actions, catalog, takeId, complexId } = useSelector(state => state.assaysCatalog);

  useEffect(() => {
    if (!catalog && takeId && complexId) dispatch(getCatalog());
  }, [catalog, dispatch, takeId, complexId]);

  return (
      <div className={classes.scrollContainer}>
        <Typography color={"textPrimary"} variant={'h5'} className={classes.headerLabel} style={{marginBottom: '20px'}}>
          Актуальні пропозиції
        </Typography>
        <div className={classes.rootWrapper}>
          {actions && typeof actions !== 'string' && actions.sort((a,b) => b.active.localeCompare(a.active)).map((item) => (
              <MediaCard item={item} key={item.id} isComponentInShop={isComponentInShop}/>))}
        </div>
        {!actions && typeof actions !== 'string' && <Loading/>}
        {actions && typeof actions === 'string' && <div className={classes.error}>Вибачте, сталась помилка під час завантаження.</div>}
      </div>
  );
}

export default ListOfPromotions;
